'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var intervalHolder = null;
var playFn = function playFn() {
  var html = '<div class="same">' + $('.cloudPopup .wrapper').html() + '</div>';
  $('.cloudPopup .wrapper').append(html);
  var len = $('.cloudPopup .wrapper>p').length;
  var num = 1;
  intervalHolder = setInterval(function () {
    var top = -1 * 26 * num;
    $('.cloudPopup .wrapper').stop().animate({ marginTop: top + 'px' }, 1500, function () {
      if (num === len) {
        num = 1;
        $('.cloudPopup .wrapper').css({ marginTop: 0 });
      } else num++;
    });
  }, 3000);
};

var clearInt = function clearInt() {
  if (!intervalHolder) return;
  clearInterval(intervalHolder);
  intervalHolder = null;
  $('.cloudPopup .wrapper .same').remove();
  $('.cloudPopup .wrapper').stop().css({ marginTop: 0 });
};

var clickFn = function clickFn() {
  if ($('.cloudPopup .wrapper>p').length < 2) return;
  $('.cloudPopup .wrapper').toggleClass('on');
  if ($('.cloudPopup .wrapper').hasClass('on')) {
    clearInt();
    $('.cloudPopup').css({ height: $('.cloudPopup .wrapper>p').length * 26 + 'px' });
  } else {
    $('.cloudPopup').css({ height: '26px' });
    playFn();
  }
};

var addNewsTip = exports.addNewsTip = function addNewsTip(key, text) {
  $('.cloudPopup .wrapper').append('<p class="tip-' + key + '">' + text + '</p>');
  $('.cloudPopup').show();
};

var removeNewsTip = exports.removeNewsTip = function removeNewsTip(key) {
  $('.cloudPopup .wrapper .tip-' + key).remove();
  if (!$('.cloudPopup .wrapper>p').length && $('.rain_colourCode').css('display') == 'none') $('.cloudPopup').hide();
};

var updateNewsTip = exports.updateNewsTip = function updateNewsTip(key, text) {
  $('.cloudPopup .wrapper .tip-' + key).html(text);
};

var showTipInfo = exports.showTipInfo = function showTipInfo(text) {
  $('.hint-content').html(text);
  $('.hint-content').css('opacity', 1);
  $('.hint-content').on('webkitTransitionEnd transitionend', function () {
    $('.hint-content').css({ 'opacity': 0, '-webkit-transition': '0.5s opacity linear 2s' });
    $('.hint-content').on('webkitTransitionEnd transitionend', function () {
      $('.hint-content').css('display', 'none');
    });
  });
};


//////////////////
// WEBPACK FOOTER
// ./js/util/newsTip.js
// module id = 32
// module chunks = 0